<template>
  <main>
    <router-view
      :service-data="serviceData"
      :active-services="activeServices"
      :inactive-services="inactiveServices"
    />
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'marketing',
  components: {},
  props: {
    serviceData: {
      type: Array,
      default: null,
      required: false,
    },
    activeServices: {
      type: Array,
      default: null,
      required: false,
    },
    inactiveServices: {
      type: Array,
      default: null,
      required: false,
    },
  },
  metaInfo: {
    title: 'Redaktionsmarketing',
  },
  computed: {
    ...mapState({
      customerId: (state) => state.user.customerId,
    }),
  },
};
</script>

<style lang="scss">
</style>
